(function(){
  var SEL = '.me-trois .me-vis, .me-cph article, .me-cards .me-ph';
  function init(racine){
    var cibles = (racine||document).querySelectorAll(SEL);
    if(!cibles.length) return;
    if(!('IntersectionObserver' in window)){
      cibles.forEach(function(el){ el.classList.add('me-vu'); });
      return;
    }
    var io = new IntersectionObserver(function(entrees){
      entrees.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('me-vu'); io.unobserve(e.target); }
      });
    }, { threshold: .15, rootMargin: '0px 0px -6% 0px' });
    cibles.forEach(function(el){
      if(el.dataset.meMotion) return;
      el.dataset.meMotion='1';
      io.observe(el);
      setTimeout(function(){ el.classList.add('me-vu'); }, 3000);
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document);});}else{init(document);}
  document.addEventListener('shopify:section:load',function(){ init(document); });
})();